<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-text-field
          label="Tunes Cycle Grant Amount"
          v-model="workingReward.amount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="amount"
        />
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col cols="12">
        <v-text-field
          label="Grant Valid For"
          v-model="workingReward.duration"
          type="number"
          hint="Ex. 30"
          suffix="days"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="duration"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { TunesGrantReward } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class TunesGrantRewardEditor extends Vue {
  @Prop()
  value!:TunesGrantReward;

  workingReward:TunesGrantReward | null = null;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as TunesGrantReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
